<template>
  <main class="main drv">

    <Breadcrumbs :breadcrumbs="breadcrumbs" />

    <!-- Hero -->
    <section class="drv-hero">
      <div class="container drv-hero__container">

        <div class="drv-hero__content">
          <div class="drv-hero__label">Движение</div>
          <h1 class="title drv-hero__title">
            Драйв —<br>жизнь в движении
          </h1>
          <p class="drv-hero__desc">
            Дорога, вода и небо. Мы ищем лучшие решения для тех, кто знает, что дорога — это не способ добраться, а способ жить.
          </p>
          <div class="drv-hero__actions">
            <NuxtLink to="/catalog" class="btn main-btn">
              Смотреть каталог
            </NuxtLink>
            <a href="#for-dealers" class="drv-hero__link">
              Разместить бренд или дилерство
            </a>
          </div>
        </div>

        <div class="drv-hero__image">
          <img
            src="/img/services/drive/hero.jpg"
            alt="Жизнь в движении — Шарунстор"
            loading="eager"
          />
        </div>

      </div>
    </section>

    <!-- Что мы делаем -->
    <section class="drv-cats">
      <div class="container">
        <h2 class="title drv-cats__title">Дорога, вода и небо</h2>

        <Swiper
          :modules="[SwiperNavigation]"
          :slides-per-view="1.3"
          :space-between="16"
          :navigation="true"
          :breakpoints="{
            640:  { slidesPerView: 2.2, spaceBetween: 20 },
            1024: { slidesPerView: 3.2, spaceBetween: 24 },
            1280: { slidesPerView: 4,   spaceBetween: 24 },
          }"
          class="drv-cats__swiper"
        >
          <SwiperSlide v-for="cat in cats" :key="cat.name">
            <NuxtLink to="/catalog" class="drv-cats__card">
              <div class="drv-cats__card-img">
                <img :src="cat.img" :alt="cat.name" loading="lazy" />
              </div>
              <div class="drv-cats__card-body">
                <h3 class="drv-cats__card-name">{{ cat.name }}</h3>
                <p class="drv-cats__card-text">{{ cat.text }}</p>
              </div>
            </NuxtLink>
          </SwiperSlide>
        </Swiper>

      </div>
    </section>

    <!-- Каталог автомобилей (скрыто) -->
    <section class="drv-preview" v-if="false && previewCars.length">
      <div class="container">

        <div class="drv-preview__head">
          <h2 class="title drv-preview__title">Каталог автомобилей</h2>
          <p class="drv-preview__desc">Справочник моделей с характеристиками. Подберите — направим к проверенному дилеру.</p>
        </div>

        <div class="drv-preview__grid">
          <NuxtLink
            v-for="car in previewCars"
            :key="car.id"
            to="/catalog/transport"
            class="drv-preview__card"
          >
            <div class="drv-preview__card-img">
              <img
                v-if="car.preview"
                :src="storageUrl(car.preview)"
                :alt="`${car.model?.brand?.name} ${car.model?.name}`"
                loading="lazy"
              />
              <div v-else class="drv-preview__card-placeholder" />
            </div>
            <div class="drv-preview__card-body">
              <div class="drv-preview__card-brand">{{ car.model?.brand?.name }}</div>
              <h3 class="drv-preview__card-model">{{ car.model?.name }}</h3>
            </div>
          </NuxtLink>
        </div>

        <div class="drv-preview__cta">
          <button class="drv-preview__btn" @click="isCarModalOpen = true">
            Отправить заявку на подбор авто
          </button>
        </div>

      </div>
    </section>

    <!-- Оффер для дилеров -->
    <section class="drv-dealers" id="for-dealers">
      <div class="drv-dealers__bg" aria-hidden="true"></div>
      <div class="container drv-dealers__inner">

        <h2 class="title drv-dealers__title">Разместите автомобили и услуги на нашей платформе</h2>
        <p class="drv-dealers__desc">Мы направляем аудиторию к дилерам — людей, которые уже выбирают, а не просто смотрят.</p>

        <div class="drv-dealers__theses">

          <div class="drv-dealers__thesis">
            <div class="drv-dealers__thesis-title">Тёплый трафик</div>
            <p class="drv-dealers__thesis-text">Наши пользователи приходят в каталог с намерением — они изучают модели, сравнивают и готовы к следующему шагу. Мы направляем их к вам.</p>
          </div>

          <div class="drv-dealers__thesis">
            <div class="drv-dealers__thesis-title">Запись на тест-драйв</div>
            <p class="drv-dealers__thesis-text">Целевое действие — не просто просмотр, а реальная запись. Мы конвертируем интерес в визит к дилеру.</p>
          </div>

          <div class="drv-dealers__thesis">
            <div class="drv-dealers__thesis-title">Ваш бренд в среде</div>
            <p class="drv-dealers__thesis-text">Присутствие в редакционных материалах, концептах и подборках Драйв — не баннерная реклама, а органичное появление в нужном контексте.</p>
          </div>

        </div>

        <button class="drv-dealers__cta" @click="isDealerModalOpen = true">
          Оставить заявку
        </button>

      </div>
    </section>

    <!-- Философия -->
    <section class="drv-phil">
      <div class="container drv-phil__container">

        <div class="drv-phil__text">
          <div class="drv-phil__label">Философия</div>
          <h2 class="title drv-phil__title">Я знаю, что скрывается под капотом</h2>
          <div class="drv-phil__body">
            <p>С 2010 года я в теме автозапчастей. Через меня прошли тысячи деталей на самые разные автомобили — и столько же историй о том, как люди выбирают, владеют и расстаются с машинами.</p>
            <p>Автомобиль — это не только красивый кузов. Это агрегат, который нужно обслуживать. И правильный выбор всегда стоит на стыке четырёх вещей: эстетика, надёжность, характеристики и доступность сервиса.</p>
            <p>Драйв появился именно из этого понимания. Мы не просто показываем модели — мы вникаем в платформу, изучаем реальный опыт владения и помогаем выбрать то, что не разочарует ни через год, ни через пять.</p>
            <p class="drv-phil__conclusion">То же самое — про воду и небо. Везде есть своя механика, своя эксплуатация, свои нюансы. Мы разбираемся.</p>
          </div>
        </div>

        <div class="drv-phil__image">
          <img
            src="/img/msharun.jpg"
            alt="Макс Шарун, основатель Шарунстор"
            loading="lazy"
          />
          <div class="drv-phil__caption">Макс Шарун, основатель Шарунстор</div>
        </div>

      </div>
    </section>

    <!-- FAQ -->
    <section class="drv-faq">
      <div class="container drv-faq__container">
        <h2 class="title drv-faq__title">Часто задаваемые вопросы</h2>
        <div class="drv-faq__list">
          <div
            v-for="(item, i) in faq"
            :key="i"
            class="drv-faq__item"
            :class="{ 'drv-faq__item--open': openFaq === i }"
          >
            <button class="drv-faq__question" @click="openFaq = openFaq === i ? null : i">
              <span>{{ item.q }}</span>
              <svg class="drv-faq__icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>
            <div class="drv-faq__answer">
              <div class="drv-faq__answer-inner">{{ item.a }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </main>

  <ClientOnly>
    <teleport to="body">
      <FormDriveCar v-if="isCarModalOpen" @close="isCarModalOpen = false" />
      <FormDriveDealer v-if="isDealerModalOpen" @close="isDealerModalOpen = false" />
    </teleport>
  </ClientOnly>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation as SwiperNavigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import Breadcrumbs from '~/components/Section/Breadcrumbs.vue'
import FormDriveCar from '~/components/Modals/FormDriveCar.vue'
import FormDriveDealer from '~/components/Modals/FormDriveDealer.vue'

const cats = [
  {
    name: 'Авто',
    text: 'Подбираем и сравниваем. Направляем к проверенным дилерам.',
    img: '/img/services/drive/cat-auto.jpg',
  },
  {
    name: 'Мото',
    text: 'Для тех, кто выбирает дорогу всем телом.',
    img: '/img/services/drive/cat-moto.jpg',
  },
  {
    name: 'Водный',
    text: 'Яхты, SUP, аренда. Вода как способ думать.',
    img: '/img/services/drive/cat-water.jpg',
  },
  {
    name: 'Воздушный',
    text: 'Частные перелёты и вертолёты. Небо без расписания.',
    img: '/img/services/drive/cat-air.jpg',
  },
]

const config  = useRuntimeConfig()
const apiBase = config.public.apiDomain

const isCarModalOpen    = ref(false)
const isDealerModalOpen = ref(false)

const { data: vibeVehiclesRes } = await useFetch(`${apiBase}/vibe-vehicles/index?vibeId=22`)
const previewCars = computed(() => vibeVehiclesRes.value?.data?.vehicles ?? [])

function storageUrl(path) {
  if (!path) return ''
  const normalised = path.replace(/\\/g, '/')
  if (normalised.startsWith('http://') || normalised.startsWith('https://')) return normalised
  return apiBase.replace(/\/api$/, '') + '/storage' + normalised
}

useHead({
  title: 'Жизнь в движении — Шарунстор',
  meta: [
    {
      name: 'description',
      content: 'Дорога, вода и небо. Лучшие решения для тех, кто знает, что дорога — это не способ добраться, а способ жить.',
    },
  ],
})

const breadcrumbs = [
  { title: 'Главная', url: '/' },
  { title: 'Движение' },
]

const openFaq = ref(null)
const faq = [
  {
    q: 'Как записаться на тест-драйв?',
    a: 'Выберите модель в каталоге и нажмите «Записаться на тест-драйв» — мы передадим заявку дилеру и он свяжется с вами для подтверждения. Эта функция скоро появится.',
  },
  {
    q: 'Вы продаёте автомобили напрямую?',
    a: 'Нет. Мы справочник и агрегатор — помогаем выбрать и направляем к проверенным дилерам. Сделка происходит напрямую между вами и дилером.',
  },
  {
    q: 'Какие марки есть в каталоге?',
    a: 'Каталог постоянно пополняется. Сейчас представлены BMW, Mercedes-Benz, Geely, Zeekr — и это только начало. Если нужной модели нет — оставьте заявку, поможем найти.',
  },
  {
    q: 'Вы работаете только с автомобилями?',
    a: 'Нет — направление Драйв охватывает также водный и воздушный транспорт. Яхты, SUP, вертолёты и частные перелёты — в разработке, следите за обновлениями.',
  },
  {
    q: 'Как дилеру разместить автомобили на платформе?',
    a: 'Оставьте заявку в блоке для дилеров — менеджер свяжется и расскажет об условиях сотрудничества.',
  },
  {
    q: 'Платформа берёт комиссию с покупателя?',
    a: 'Нет. Для покупателя всё бесплатно. Мы работаем с дилерами и брендами.',
  },
]
</script>

<style scoped lang="scss">
$dark: #1B1918;
$grey: #666;
$mobile: 48em;
$tablet: 75em;

// ─── Категории ────────────────────────────────────────────────────────────────
.drv-cats {
  padding: 10rem 0;
  background: #f7f7f5;

  &__title {
    margin-bottom: 4.8rem;
    text-align: center;
  }

  &__card {
    display: block;
    text-decoration: none;
    color: $dark;

    &:hover &-img img { transform: scale(1.04); }
  }

  &__card-img {
    position: relative;
    aspect-ratio: 3 / 4;
    overflow: hidden;
    background: #e8e6e3;
    margin-bottom: 1.8rem;
    border-radius: 0.2rem;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      transition: transform 0.5s ease;
    }
  }

  &__card-name {
    font-size: 1.8rem;
    font-weight: 600;
    margin-bottom: 0.8rem;
    color: $dark;
  }

  &__card-text {
    font-size: 1.4rem;
    line-height: 1.6;
    color: $grey;
  }

  @media (max-width: $mobile) {
    padding: 6rem 0;
    &__title { margin-bottom: 3.2rem; }
  }
}

// ─── Превью каталога ──────────────────────────────────────────────────────────
.drv-preview {
  padding: 10rem 0;
  background: #fff;

  &__head {
    text-align: center;
    max-width: 64rem;
    margin: 0 auto 5rem;
  }

  &__title { margin-bottom: 1.6rem; }

  &__desc {
    font-size: 1.7rem;
    line-height: 1.6;
    color: $grey;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 2.4rem;

    @media (max-width: $tablet) { grid-template-columns: repeat(2, 1fr); }
    @media (max-width: $mobile) { grid-template-columns: repeat(2, 1fr); gap: 1.6rem; }
  }

  &__card {
    display: block;
    text-decoration: none;
    color: $dark;

    &:hover &-img img { transform: scale(1.04); }
  }

  &__card-img {
    aspect-ratio: 3 / 4;
    overflow: hidden;
    background: #f0efed;
    margin-bottom: 1.6rem;
    border-radius: 0.2rem;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      transition: transform 0.45s ease;
    }
  }

  &__card-placeholder {
    width: 100%;
    height: 100%;
    background: #e8e6e3;
  }

  &__card-brand {
    font-size: 1.1rem;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: rgba(27, 25, 24, 0.4);
    margin-bottom: 0.5rem;
  }

  &__card-model {
    font-size: 1.7rem;
    font-weight: 600;
    margin-bottom: 0.6rem;
    color: $dark;
  }

  &__card-gen {
    font-size: 1.3rem;
    color: $grey;
  }

  &__cta {
    margin-top: 5rem;
    text-align: center;
  }

  &__btn {
    display: inline-block;
    padding: 1.4rem 3.6rem;
    border: 1px solid $dark;
    font-size: 1.4rem;
    font-weight: 500;
    letter-spacing: 0.06em;
    color: $dark;
    text-decoration: none;
    transition: background 0.2s, color 0.2s;

    &:hover {
      background: $dark;
      color: #fff;
    }
  }

  @media (max-width: $mobile) {
    padding: 6rem 0;
    &__head { margin-bottom: 3.2rem; }
    &__cta { margin-top: 3.2rem; }
  }
}

// ─── Hero ─────────────────────────────────────────────────────────────────────
.drv-hero {
  padding: 6rem 0 8rem;

  &__container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6rem;
    align-items: center;

    @media (max-width: $tablet) {
      grid-template-columns: 1fr;
      gap: 4rem;
    }
  }

  &__label {
    font-size: 1.2rem;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: rgba(27, 25, 24, 0.4);
    margin-bottom: 2.4rem;
  }

  &__title {
    font-size: 5.6rem;
    line-height: 1.08;
    margin-bottom: 2rem;
    color: $dark;

    @media (max-width: $tablet) { font-size: 4.2rem; }
    @media (max-width: $mobile) {
      font-size: 3.4rem;
      br { display: none; }
    }
  }

  &__desc {
    font-size: 1.8rem;
    line-height: 1.6;
    color: $grey;
    margin-bottom: 3.2rem;
    max-width: 48rem;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 3.2rem;
    flex-wrap: wrap;
  }

  &__link {
    font-size: 1.4rem;
    color: $dark;
    text-decoration: underline;
    text-underline-offset: 0.3em;
    opacity: 0.55;
    transition: opacity 0.2s;

    &:hover { opacity: 1; }
  }

  &__image {
    img {
      width: 100%;
      height: 60rem;
      object-fit: cover;
      display: block;
      border-radius: 0.4rem;

      @media (max-width: $tablet) { height: 44rem; }
      @media (max-width: $mobile) { height: 30rem; }
    }

    @media (max-width: $tablet) { order: -1; }
  }
}

// ─── Оффер для дилеров ───────────────────────────────────────────────────────
.drv-dealers {
  position: relative;
  padding: 12rem 0;
  overflow: hidden;

  &__bg {
    position: absolute;
    inset: 0;
    background: url('/img/services/drive/for-dealers.jpg') center / cover no-repeat;
    filter: brightness(0.3);
  }

  &__inner {
    position: relative;
    z-index: 1;
    max-width: 96rem;
  }

  &__title {
    color: #fff;
    margin-bottom: 2rem;
  }

  &__desc {
    font-size: 1.8rem;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.55);
    margin-bottom: 6rem;
    max-width: 60rem;
  }

  &__theses {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 4rem;
    margin-bottom: 6rem;

    @media (max-width: $tablet) {
      grid-template-columns: 1fr;
      gap: 3.2rem;
    }
  }

  &__thesis-title {
    font-size: 1.6rem;
    font-weight: 600;
    color: #fff;
    margin-bottom: 1.2rem;
  }

  &__thesis-text {
    font-size: 1.5rem;
    color: rgba(255, 255, 255, 0.5);
    line-height: 1.7;
  }

  &__cta {
    display: inline-block;
    padding: 1.6rem 4rem;
    background: #fff;
    color: #1B1918;
    font-size: 1.4rem;
    font-weight: 600;
    letter-spacing: 0.06em;
    border: none;
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover { opacity: 0.88; }
  }

  @media (max-width: $mobile) {
    padding: 8rem 0;
    &__desc { margin-bottom: 4rem; }
    &__theses { margin-bottom: 4rem; }
  }
}

// ─── Философия ────────────────────────────────────────────────────────────────
.drv-phil {
  padding: 10rem 0;
  background: #f7f7f5;

  &__container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8rem;
    align-items: center;

    @media (max-width: $tablet) {
      grid-template-columns: 1fr;
      gap: 4.8rem;
    }
  }

  &__label {
    font-size: 1.2rem;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: rgba(27, 25, 24, 0.35);
    margin-bottom: 2.4rem;
  }

  &__title { margin-bottom: 3.2rem; }

  &__body {
    display: flex;
    flex-direction: column;
    gap: 1.8rem;

    p {
      font-size: 1.7rem;
      line-height: 1.7;
      color: $grey;
    }
  }

  &__conclusion {
    font-size: 1.7rem !important;
    line-height: 1.6 !important;
    color: $dark !important;
    font-style: italic;
    padding-top: 0.8rem;
    border-top: 1px solid rgba(27, 25, 24, 0.1);
    margin-top: 0.4rem;
  }

  &__image {
    @media (max-width: $tablet) { order: -1; }

    img {
      width: 100%;
      height: 60rem;
      object-fit: cover;
      object-position: top;
      display: block;
      border-radius: 0.4rem;

      @media (max-width: $tablet) { height: 44rem; }
      @media (max-width: $mobile) { height: 32rem; }
    }
  }

  &__caption {
    margin-top: 1.4rem;
    font-size: 1.3rem;
    color: rgba(27, 25, 24, 0.4);
    letter-spacing: 0.04em;
  }

  @media (max-width: $mobile) { padding: 6rem 0; }
}

// ─── FAQ ──────────────────────────────────────────────────────────────────────
.drv-faq {
  padding: 10rem 0;
  background: #f7f7f5;

  &__container { max-width: 80rem; }

  &__title { margin-bottom: 5rem; }

  &__list { display: flex; flex-direction: column; }

  &__item {
    border-bottom: 1px solid rgba(27, 25, 24, 0.1);

    &:first-child { border-top: 1px solid rgba(27, 25, 24, 0.1); }

    &--open .drv-faq__icon { transform: rotate(180deg); }
    &--open .drv-faq__answer { max-height: 40rem; }
  }

  &__question {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;
    padding: 2.4rem 0;
    background: none;
    border: none;
    cursor: pointer;
    text-align: left;
    font-size: 1.6rem;
    font-weight: 500;
    color: $dark;
    font-family: inherit;
    line-height: 1.4;
  }

  &__icon {
    flex-shrink: 0;
    color: $dark;
    transition: transform 0.3s ease;
  }

  &__answer {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.35s ease;
  }

  &__answer-inner {
    padding-bottom: 2.4rem;
    font-size: 1.5rem;
    line-height: 1.7;
    color: $grey;
  }

  @media (max-width: $mobile) {
    padding: 6rem 0;
    &__title { margin-bottom: 3.2rem; }
    &__question { font-size: 1.5rem; }
  }
}
</style>
